/******************************************************************************************
 *	Device Licensing Eligibility Service
 *******************************************************************************************
 *
 * Service to determine whether a given customer is eligible for device licensed products.
 *
 */
(function() {
  

  angular.module('rcServices.deviceLicensingEligibility', []).service(
    'DeviceLicensingEligibility',
    /* @ngInject */
    function(_, MARKET_SEGMENTS) {
      //Array of market-segment + anniversary pairs.
      //If at least one of the pairs is satisfied, the customer is eligible.
      //Customer's anniversary date must be greater than or equal to (a.k.a. after) the one in the array.
      var eligibilityCriteria = [
        {
          marketSegment: MARKET_SEGMENTS.EDUCATION,
          anniversaryDate: '2015-05-01T00:00:00-07:00' //May 1, 2015 PST
        }
      ];
      this.evaluate = function(customer) {
        //Eligibility is based on market segment and anniversary date, so both must exist
        if (customer && customer.marketSegment && customer.anniversaryDate) {
          return _.some(eligibilityCriteria, function(criteria) {
            return (
              MARKET_SEGMENTS[customer.marketSegment] === criteria.marketSegment &&
              customer.anniversaryDate >= criteria.anniversaryDate
            );
          });
        }
        return false;
      };
    }
  );
})();
